import { z } from 'zod'
import { EngagementOptionEnumValues } from '@forgd/shared/enums'

export const GetMMComparisonQuery = z.object({
  date: z.string().date(),
  orderBook: z.string().nullish(),
  marketMakerId: z.string().nullish(),
  exchangeId: z.string().nullish(),
  daysLookback: z.coerce.number().int().positive().nullish(),
})

export type GetMMComparisonQueryType = z.infer<typeof GetMMComparisonQuery>

export const GetMMComparisonResult = z.array(
  z.object({
    avgFillVolume: z.number().safe().nullable(),
    avgDepth: z.number().safe().nullable(),
    avgSpread: z.number().safe().nullable(),
    avgVolumeBasedLoanUtil: z.number().safe().nullable(),
    avgLiquidityBasedLoanUtil: z.number().safe().nullable(),
    mmId: z.string(),
    engagementType: z.enum(EngagementOptionEnumValues),
    mmName: z.string(),
    mmImageUrl: z.string().nullable(),
    totalDaysTracked: z.number().safe().int(),
  }),
)
